export default __webpack_public_path__ + "static/media/logo.adfc1c8d.png";